import React, { useState } from 'react'
import { useAlert } from '../../../context/AlertContext';
import { Dialog, DialogActions, DialogContent, IconButton, LinearProgress, Tooltip } from '@mui/material';
import { Add, Edit } from '@mui/icons-material';
import clinicServices from '../clinicServices';

function ClinicForm({data, callBack }) {
    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [title,setTitle] = useState("");
    const [details,setDetails] =useState("");
    
    
    

    
    const addNew = ()=>{
        setDialogStatus(true);
    }

    const updateData = ()=>{
        setTitle(data.title);
        setDetails(data.details)
        setDialogStatus(true);
    }

    const handleClose = () =>{
        setDialogStatus(false)
    }

    const onSubmit = () => {
        const payload = {
          title:title,
          details :details,
        }
        if(data){ //Updating Existing
          payload.id = data.id;
        }
        setSavingStatus(true);
        clinicServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack(res.id)
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    
    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Setup New Clinic</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12 mb-2'>
                             <label className="form-label fw-bold">Title</label>
                            <input className='form-control' type="text" value={title} placeholder='Title' onChange={(e)=>setTitle(e.target.value)}  ></input>
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label className="fform-label fw-bold">Details</label>
                            <textarea className='form-control' type="text" value={details} placeholder='Clinic Details' onChange={(e)=>setDetails(e.target.value)}  />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className="row mt-3">
                        <div className='col-md-12'>
                            {savingInProgress ?
                                <LinearProgress/>
                                :
                                <>
                                    <button className="btn btn-primary float-end" onClick={onSubmit} type="button" disabled={title===""} >Save</button>
                                    <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                </>
                            }
                        </div>
                        <div className='col-md-12'>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ClinicForm